/**
 * Created by Ivan on 09.12.2025
 */

const LightningRushGardenFinishWindow = CleverappsWindow.extend({
    onWindowLoaded: function (mission) {
        this.mission = mission;

        this._super({
            name: "LightningRushGardenFinishWindow",
            content: this.createContent(),
            noBackground: true,
            closeButton: true,
            contentPadding: cleverapps.styles.LightningRushGardenFinishWindow.contentPadding,
            notCloseByTouchInShadow: true
        });

        cleverapps.focusManager.hideControlsWhileFocused("MenuBarLivesItem");

        this.mission.updateCompetitionResults();

        this.mission.logEvent(Mission.EVENTS.MISSION_WINDOW);
    },

    createContent: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow;

        const content = this.content = new cc.Node();
        content.setAnchorPoint(0.5, 0.5);
        content.setContentSize2(styles.size);

        this.createBg();
        this.createResults();
        this.createTitle();
        this.createTimer();
        this.createTable();
        this.createButton();

        return content;
    },

    createBg: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow;

        const bg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.bg_png);
        bg.setContentSize2(styles.size);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        const leftEar = new cc.Sprite(bundles.lightning_rush_frame.frames.decor_ear_png);
        bg.addChild(leftEar, -1);
        leftEar.setScaleX(-1);
        leftEar.setAlignment(styles.bg.leftEar);

        const rightEar = new cc.Sprite(bundles.lightning_rush_frame.frames.decor_ear_png);
        bg.addChild(rightEar, -1);
        rightEar.setAlignment(styles.bg.rightEar);
    },

    createResults: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow.results;
        const bg = new cc.Scale9Sprite(bundles.lightning_rush_finish_window.frames.picture_png);
        bg.setContentSize2(styles.bg);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        const rankTitle = cleverapps.UI.generateOnlyText(Messages.get("LightningRushGardenFinishWindow.Rank"), cleverapps.styles.FONTS.LR_RESULTS_TEXT);
        rankTitle.fitTo(styles.rank);
        rankTitle.setAlignment(styles.rank);
        bg.addChild(rankTitle);

        const rewardTitle = cleverapps.UI.generateOnlyText(Messages.get("LightningRushGardenFinishWindow.Reward"), cleverapps.styles.FONTS.LR_RESULTS_TEXT);
        rewardTitle.fitTo(styles.reward);
        rewardTitle.setAlignment(styles.reward);
        bg.addChild(rewardTitle);

        const rankBg = new cc.Scale9Sprite(bundles.lightning_rush_finish_window.frames.rank_bg_png);
        rankBg.setContentSize2(styles.rankBg.width, rankBg.height);
        bg.addChild(rankBg);
        rankBg.setAlignment(styles.rankBg);

        const club = new cc.Sprite(bundles.lightning_rush_finish_window.frames.club_rank_png);
        rankBg.addChild(club);
        club.setAlignment(styles.rankBg.club);

        const place = this.mission.runningCompetition.calcPlace() + 1;

        const text = cleverapps.UI.generateOnlyText(`#${place}`, cleverapps.styles.FONTS.LR_RANK_TEXT);
        rankBg.addChild(text);
        text.setAlignment(styles.rankBg.text);
        const empty = new cc.Sprite(bundles.lightning_rush_finish_window.frames.prize_empty_png);
        bg.addChild(empty);
        empty.setAlignment(styles.prize.empty);

        if (place === 1) {
            const chest = new cc.Sprite(bundles.lightning_rush_finish_window.frames.prize_chest_png);
            bg.addChild(chest);
            chest.setAlignment(styles.prize.chest);
        } else {
            const emptyText = cleverapps.UI.generateOnlyText("x", cleverapps.styles.FONTS.LR_EMPTY_TEXT);
            empty.addChild(emptyText);
            emptyText.setAlignment(styles.prize.empty.emptyText);
        }
    },

    createTitle: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow;
        const titleBg = new cc.Scale9Sprite(bundles.lightning_rush_frame.frames.half_title_png);
        titleBg.setContentSize2(styles.title.bg.width, titleBg.height);
        this.content.addChild(titleBg);
        titleBg.setAlignment(styles.title.bg);

        const title = cleverapps.UI.generateOnlyText(Messages.get("Missions.LightningRushFinish.Title"), cleverapps.styles.FONTS.LIGHTNING_RUSH_GARDEN_TITLE_TEXT);
        this.content.addChild(title);
        title.setAlignment(styles.title);
        title.fitTo(styles.title.width);
    },

    createTimer: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow.timer;

        const bg = new cc.Scale9Sprite(bundles.lightning_rush_finish_window.frames.finish_substrate_png);
        bg.setContentSize2(styles.bg.width, bg.height);
        this.content.addChild(bg);
        bg.setAlignment(styles.bg);

        const text = cleverapps.UI.generateOnlyText(Messages.get("Missions.windowFinished"), cleverapps.styles.FONTS.LIGHTNING_RUSH_GARDEN_TIMER_TEXT);
        text.fitTo(styles.width, styles.height);

        const icon = this.icon = new cc.Sprite(bundles.timer.frames.timer_png);
        icon.setScale(0.9);

        const layout = new cleverapps.Layout([icon, text], {
            direction: cleverapps.UI.HORIZONTAL,
            margin: styles.margin
        });
        bg.addChild(layout);
        layout.setAlignment(styles);
    },

    createButton: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow.button;

        const button = new cleverapps.UI.Button({
            width: styles.width,
            height: styles.height,
            type: cleverapps.styles.UI.Button.Images.button_green,
            onClicked: () => {
                this.close();
                if (this.mission.getPrize()) {
                    this.mission.logic.receivePrize();
                }
            }
        });

        const msg = this.mission.logic.isPrizeState() ? "LightningRushGardenFinishWindow.Button.Prize" : "LightningRushGardenFinishWindow.Button.Continue";
        const text = cleverapps.UI.generateOnlyText(Messages.get(msg), cleverapps.styles.FONTS.LIGHTING_RUSH_START_BUTTON_TEXT);
        button.addChild(text);
        text.setAlignment(styles.text);
        cleverapps.UI.fitToBox(text, { width: button.width * 0.7, height: button.height * 0.9 });
        this.content.addChild(button);
        button.setAlignment(styles);
    },

    createTable: function () {
        const styles = cleverapps.styles.LightningRushGardenFinishWindow.table;

        const mission = this.mission;
        const table = this.mission.runningCompetition.table;
        const tableView = this.tableView = new cleverapps.UI.ScrollView(new cc.Node(), {
            mouseScroll: false,
            touchScroll: false,
            dock: { toEnd: false }
        });

        new TableHandler(table, tableView, {
            id: mission.type,
            height: styles.height,
            rowConstructor: LightningRushGardenFinishRowView,
            rowOptions: {
                width: styles.width,
                height: styles.rowHeight,
                dataIcon: bundles.tablerow_icons.frames.lighting_rush_tablerow_icon,
                mission
            },
            styles: cleverapps.styles.LightningRushGardenFinishWindow.tableStyles
        });

        tableView.setAnchorPoint(0.5, 0.5);
        this.content.addChild(tableView);
        tableView.setAlignment(styles);
    },

    onShow: function () {
        this._super();

        this.mission.runningCompetition.table.showUp();
    },

    onClose: function () {
        if (this.mission.runningCompetition) {
            this.mission.runningCompetition.updateShownPlace();
        }
        this.mission.updateMissionIcon();

        if (this.mission.getPrize()) {
            this.mission.logic.receivePrize();
        }

        this._super();
    },

    listBundles: function () {
        return ["lightning_rush_finish_window"];
    }
});

cleverapps.overrideColors(cleverapps.styles.COLORS, {
    LR_FINISH_TEXT: new cc.Color(114, 41, 112, 255)
});

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    LR_RESULTS_TEXT: {
        name: "default",
        size: 48,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHTNING_RUSH_WINDOW_TITLE_STROKE
    },
    LR_RANK_TEXT: {
        name: "default",
        size: 68,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHTNING_RUSH_WINDOW_TITLE_STROKE
    },
    LR_EMPTY_TEXT: {
        name: "default",
        size: 96,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.LIGHTNING_RUSH_WINDOW_TITLE_STROKE
    }
});

cleverapps.styles.LightningRushGardenFinishWindow = {
    size: {
        width: 660,
        height: 1100
    },

    bg: {
        x: { align: "center" },
        y: { align: "center" },

        leftEar: {
            x: { align: "left", dx: 0 },
            y: { align: "top", dy: 180 }
        },
        rightEar: {
            x: { align: "right", dx: 0 },
            y: { align: "top", dy: 180 }
        }
    },

    timer: {
        width: 150,
        height: 60,

        margin: 10,
        x: { align: "center", dx: -15 },
        y: { align: "center", dy: 10 },

        icon: {
            x: { align: "center", dx: -80 },
            y: { align: "center", dy: 10 }
        },
        bg: {
            width: 705,
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 150 }
        }
    },

    tableStyles: {
        size: {
            width: 500,
            height: 500
        },

        margin: 3,
        padding: { x: 6, y: 2 },
        innerPadding: { x: 6, y: 0 },

        pinnedDy: 0,

        barPadding: {
            cornerPadding: 20,
            sidePadding: 5
        }
    },
    table: {
        margin: -2,
        x: { align: "center" },
        y: { align: "bottom", dy: 145 },
        width: 630,
        height: 510,
        rowHeight: 100
    },

    results: {
        bg: {
            width: 660,
            height: 375,
            x: { align: "center" },
            y: { align: "center", dy: 360 }
        },

        rank: {
            width: 300,
            x: { align: "center", dx: -120 },
            y: { align: "top", dy: -70 }
        },

        reward: {
            width: 250,
            x: { align: "center", dx: 155 },
            y: { align: "top", dy: -70 }
        },

        rankBg: {
            width: 200,
            height: 90,
            x: { align: "center", dx: -110 },
            y: { align: "top", dy: -180 },
            club: {
                x: { align: "left", dx: -60 },
                y: { align: "center", dy: 0 }
            },
            text: {
                x: { align: "center", dx: 27 },
                y: { align: "center", dy: 3 }
            }
        },

        prize: {
            chest: {
                x: { align: "center", dx: 155 },
                y: { align: "center", dy: -40 }
            },

            empty: {
                x: { align: "center", dx: 155 },
                y: { align: "center", dy: -40 },
                emptyText: {
                    x: { align: "center", dx: 0 },
                    y: { align: "center", dy: 0 }
                }
            }
        }
    },

    title: {
        bg: {
            width: 800,
            x: { align: "center" },
            y: { align: "top", dy: 93 }
        },

        x: { align: "center" },
        y: { align: "top", dy: 64 },
        width: 400
    },

    contentPadding: {
        top: 250
    },

    button: {
        width: 308,
        height: 102,
        x: { align: "center" },
        y: { align: "bottom", dy: 25 },

        text: {
            margin: 0,
            x: { align: "center" },
            y: { align: "center" }
        }
    }
};
